import { useState } from 'react';

import { FileAttachement, LinkAttachement, PartialFileAttachement, PartialLinkAttachement } from './types';
import { InteractableMap } from './use-interactable-map';

export interface ContextMenu {
  activeMenu: ContextMenuType | undefined;
  setActiveMenu: React.Dispatch<React.SetStateAction<ContextMenuType | undefined>>;
  activeTab: number;
  setActiveTab: React.Dispatch<React.SetStateAction<number>>;
  toggleContextMenu: (menu: ContextMenuType) => void;
  hideContextMenu: () => void;
}

type UseContextMenu = {
  interactableMap: InteractableMap;
};

export type ContextMenuType =
  | {
      type: 'edit-node';
    }
  | {
      type: 'add-file-attachement';
      onCreateClick: (attachement: PartialFileAttachement | undefined) => void;
    }
  | {
      type: 'add-link-attachement';
      onCreateClick: (attachement: PartialLinkAttachement | undefined) => void;
    }
  | {
      type: 'edit-file-attachement';
      nodeId: string;
      attachement?: FileAttachement;
    }
  | {
      type: 'edit-link-attachement';
      nodeId: string;
      attachement?: LinkAttachement;
    }
  | {
      type: 'format-text';
      updateHtml: () => void;
    }
  | {
      type: 'link-text';
      url: string;
      onUpdateURL: (url: string) => void;
    };

export const useMindmapContextMenu = ({ interactableMap }: UseContextMenu): ContextMenu => {
  const { hideContextMenu: mapHideContextMenu } = interactableMap;
  const [activeMenu, setActiveMenu] = useState<ContextMenuType | undefined>();
  // activeTab stores the current selected menu-item of the "edit-node" context menu
  const [activeTab, setActiveTab] = useState<number>(-1);

  const toggleContextMenu = (menu?: ContextMenuType) => {
    if (activeMenu) setActiveMenu(undefined);
    else setActiveMenu(menu);
  };

  const hideContextMenu = () => {
    setActiveMenu(undefined);
    mapHideContextMenu();
  };

  return { activeMenu, setActiveMenu, toggleContextMenu, hideContextMenu, activeTab, setActiveTab };
};
